import React, { useEffect, useState } from "react";
import axios from "axios";
import { NavLink, Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import config from "../../Config";
import StudentPanelMenu from "./StudentPanelMenu";
import StudentRightsCheck from "./StudentRightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";
import imgBus from "../../assets/images/dashboard_icon/bus_route.svg";

function formatMoney(n) {
  if (n == null || n === "" || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

function StudentPanelTransport() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    document.title = "Transport - Student Panel";
  }, []);

  useEffect(() => {
    setLoading(true);
    const payload = {
      AccessKey,
      UserID: parseInt(UserID, 10) || 0,
      MemberType: MemberType || "Student",
      Student_ID: parseInt(UserID, 10) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "Student/GetStudentTransportPanel",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setData(res.data);
        } else {
          setData(null);
          toast.error(res.data.status_message || "Could not load transport.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        setData(null);
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, MemberType]);

  const renderUsesTransport = () => {
    const r = data.Route;
    const sec = data.Route_Section;
    return (
      <div className="row g-4">
        <div className="col-12">
          <div
            className="rounded-3 p-4 text-white position-relative overflow-hidden"
            style={{
              background:
                "linear-gradient(135deg, #1e3a5f 0%, #0d6efd 45%, #6ea8fe 100%)",
              boxShadow: "0 12px 40px rgba(13, 110, 253, 0.25)",
            }}
          >
            <div className="row align-items-center">
              <div className="col-auto">
                <img
                  src={imgBus}
                  alt=""
                  style={{ width: 72, height: 72, opacity: 0.95 }}
                />
              </div>
              <div className="col">
                <div className="small text-white-50 text-uppercase fw-semibold mb-1">
                  Your transport route
                </div>
                <h2 className="h4 mb-1 fw-bold text-white">
                  {r?.Area_Name || r?.Root_Name || "—"}
                </h2>
                <div className="text-white-50 small">
                  {r?.Root_Code && (
                    <span className="me-3">Code: {r.Root_Code}</span>
                  )}
                  {r?.Zone && <span>Zone: {r.Zone}</span>}
                </div>
              </div>
              <div className="col-md-4 mt-3 mt-md-0">
                <div className="bg-white bg-opacity-10 rounded-3 p-3 border border-white border-opacity-25">
                  <div className="small text-white-50">Fee type</div>
                  <div className="fw-semibold">{data.Fee_Type_Label}</div>
                  <div className="small text-white-50 mt-2">
                    Applicable monthly transport fee
                  </div>
                  <div className="fs-4 fw-bold">
                    {formatMoney(data.Applicable_Monthly_Fee)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {(r?.BusNumber || r?.BusDetails || r?.Root_Details) && (
          <div className="col-md-6">
            <div className="card h-100 border-0 shadow-sm">
              <div className="card-body">
                <h6 className="text-muted text-uppercase small fw-bold mb-3">
                  Vehicle & route details
                </h6>
                {r.BusNumber && (
                  <p className="mb-2">
                    <strong>Bus / vehicle no.</strong> {r.BusNumber}
                  </p>
                )}
                {r.BusDetails && (
                  <p className="mb-2 text-muted small">{r.BusDetails}</p>
                )}
                {r.Root_Details && (
                  <p className="mb-0 small">{r.Root_Details}</p>
                )}
              </div>
            </div>
          </div>
        )}

        {sec && (
          <div className="col-md-6">
            <div className="card h-100 border-0 shadow-sm">
              <div className="card-body">
                <h6 className="text-muted text-uppercase small fw-bold mb-3">
                  Route section
                </h6>
                <p className="mb-1 fw-semibold">{sec.Route_Section_Name}</p>
                {sec.Route_Section_Code && (
                  <p className="mb-0 small text-muted">Code: {sec.Route_Section_Code}</p>
                )}
                {sec.Route_Section_Details && (
                  <p className="mb-0 small mt-2">{sec.Route_Section_Details}</p>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <h6 className="text-muted text-uppercase small fw-bold mb-3">
                Latest fee challan — transport
              </h6>
              {!data.Latest_Challan_No ? (
                <p className="text-muted mb-0">No challan generated yet.</p>
              ) : (
                <>
                  <p className="mb-2">
                    <strong>Challan</strong> {data.Latest_Challan_No}
                    {data.Latest_Challan_Month > 0 && data.Latest_Challan_Year > 0 && (
                      <span className="text-muted">
                        {" "}
                        · {data.Latest_Challan_Month}/{data.Latest_Challan_Year}
                      </span>
                    )}
                    {data.Latest_Challan_Due_Date && (
                      <span className="text-muted">
                        {" "}
                        · Due: {data.Latest_Challan_Due_Date}
                      </span>
                    )}
                  </p>
                  {!data.Latest_Challan_Has_Transport ? (
                    <div className="alert alert-light border mb-0">
                      This challan has no transport charges (you are not billed
                      for transport on this challan).
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-hover mb-0 align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Description</th>
                            <th>Route code</th>
                            <th className="text-end">Amount</th>
                            <th className="text-center">Days</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(data.Latest_Challan_Transport_Lines || []).map(
                            (row, idx) => (
                              <tr key={idx}>
                                <td>
                                  <div className="small fw-semibold">
                                    {row.Description || row.FeeCode}
                                  </div>
                                  {row.FeeCode && (
                                    <div className="text-muted small">
                                      {row.FeeCode}
                                    </div>
                                  )}
                                </td>
                                <td>{row.BusRoute_Code || "—"}</td>
                                <td className="text-end">
                                  {formatMoney(row.ReceiveableFee)}
                                </td>
                                <td className="text-center small text-muted">
                                  {row.BusAvailDays != null &&
                                  row.BusMonthlyDays != null &&
                                  row.BusMonthlyDays > 0
                                    ? `${row.BusAvailDays} / ${row.BusMonthlyDays}`
                                    : "—"}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <p className="small text-muted mt-2 mb-0">
                    <Link
                      to="/student-panel/student-ledger"
                      onClick={scrollToTop}
                    >
                      View all challans
                    </Link>
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderNoTransport = () => {
    const routes = data.Available_Routes || [];
    return (
      <div>
        <div className="alert alert-info border-0 mb-4" style={{ background: "rgba(13, 110, 253, 0.08)" }}>
          <strong>No transport assigned.</strong> You are not currently using
          school transport. Below are the routes available at the school. Contact
          the office to register or change transport.
        </div>
        <div className="row g-3">
          {routes.length === 0 ? (
            <div className="col-12">
              <p className="text-muted mb-0">No route list is available.</p>
            </div>
          ) : (
            routes.map((r) => (
              <div key={r.Root_ID} className="col-md-6 col-xl-4">
                <div className="card h-100 border-0 shadow-sm transport-route-card">
                  <div className="card-body d-flex flex-column">
                    <div className="d-flex align-items-start gap-2 mb-2">
                      <img src={imgBus} alt="" width={28} height={28} />
                      <div>
                        <h6 className="mb-0 fw-bold">{r.Area_Name || r.Root_Name}</h6>
                        <div className="small text-muted">
                          {r.Root_Code && <span>Code {r.Root_Code}</span>}
                          {r.Zone && (
                            <span>
                              {r.Root_Code ? " · " : ""}
                              Zone {r.Zone}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    {r.BusNumber && (
                      <p className="small mb-2">
                        <strong>Bus</strong> {r.BusNumber}
                      </p>
                    )}
                    {r.Root_Details && (
                      <p className="small text-muted flex-grow-1 mb-3">
                        {r.Root_Details}
                      </p>
                    )}
                    <div className="border-top pt-3 mt-auto">
                      <div className="row g-2 small">
                        <div className="col-4">
                          <div className="text-muted">Pick up</div>
                          <div className="fw-semibold">{formatMoney(r.PickUp_Fee)}</div>
                        </div>
                        <div className="col-4">
                          <div className="text-muted">Drop off</div>
                          <div className="fw-semibold">{formatMoney(r.DropOf_Fee)}</div>
                        </div>
                        <div className="col-4">
                          <div className="text-muted">Pick &amp; drop</div>
                          <div className="fw-semibold">{formatMoney(r.PickDrop_Fee)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <StudentPanelMenu />
      <ToastContainer />
      <StudentRightsCheck />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink onClick={scrollToTop} to="/student-panel/dashboard">
                        Dashboard
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Transport
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Transport</div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content mt-3 pb-5">
          <div className="container">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" role="status" />
              </div>
            ) : !data ? (
              <p className="text-muted">Unable to load transport information.</p>
            ) : data.UsesTransport ? (
              renderUsesTransport()
            ) : (
              renderNoTransport()
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentPanelTransport;
